import { httpPutRequestWithCredentialsAcceptString } from "clients/phronesisClient"

interface ChangePasswordPayload {
	old_password: string
	new_password: string
}

type ChangePasswordResponse =
	| {
			code: number
			errCode: string
			message: string
	  }
	| string

type ChangePasswordResultError = {
	response: {
		data: ChangePasswordResponse
	}
}

export enum ChangePasswordResult {
	Success = "success",
	IncorrectOldPassword = "incorrect_old_password",
	Error = "error",
}

enum ErrorCodes {
	IncorrectOldPassword = "AUTH-0002",
}

const parseResult = (response: ChangePasswordResponse) => {
	if (typeof response === "string") {
		return ChangePasswordResult.Success
	}
	if (response.errCode === ErrorCodes.IncorrectOldPassword) {
		return ChangePasswordResult.IncorrectOldPassword
	}
	return ChangePasswordResult.Error
}

const parseError = (error: any) => {
	const data = (error as ChangePasswordResultError).response?.data
	if (data) return parseResult(data)
	return ChangePasswordResult.Error
}

export const changePw = async (
	password: string,
	token: string
): Promise<ChangePasswordResult> => {
	const payload: ChangePasswordPayload = {
		old_password: password,
		new_password: token,
	}
	return await httpPutRequestWithCredentialsAcceptString<
		string | ChangePasswordResponse
	>("/change-password", payload)
		.then(parseResult)
		.catch(parseError)
}
